'use client';

import { useSearchParams } from 'next/navigation';
import { Trans, useTranslation } from 'react-i18next';

/**
 * Sticky banner shown whenever {@code ?mode=draft} is present in the
 * URL. Renders outside the {@code SiteShellPresenter} so it pins to
 * the very top of the viewport regardless of which shell/header
 * variant is active.
 *
 * <p>Client-side because App Router server layouts can't read
 * {@code searchParams} — only pages can. A two-line client component
 * keeps the banner omnipresent without requiring every page to
 * thread params through.
 */
export function DraftBanner() {
  const { t } = useTranslation('site-builder-runtime');
  const params = useSearchParams();
  if (params.get('mode') !== 'draft') return null;
  return (
    <div className="draft-banner">
      <Trans t={t} i18nKey="draft.banner" components={{ b: <strong />, c: <code /> }} />
    </div>
  );
}
